<script setup>
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { messageStamp } from 'shared/helpers/timeHelper';
import { useI18n } from 'vue-i18n';

defineProps({
  inboxName: {
    type: String,
    default: '',
  },
  inboxIcon: {
    type: String,
    default: '',
  },
  scheduledAt: {
    type: Number,
    default: 0,
  },
  stats: {
    type: Object,
    default: () => ({
      sent: 0,
      delivered: 0,
      read: 0,
      failed: 0,
      replied: 0,
    }),
  },
});

const { t } = useI18n();
</script>

<template>
  <span class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap">
    {{ t('CAMPAIGN.SMS.CARD.CAMPAIGN_DETAILS.SENT_FROM') }}
  </span>
  <div class="flex items-center gap-1.5 flex-shrink-0">
    <Icon :icon="inboxIcon" class="flex-shrink-0 text-n-slate-12 size-3" />
    <span class="text-sm font-medium text-n-slate-12">
      {{ inboxName }}
    </span>
  </div>

  <span class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap">
    {{ t('CAMPAIGN.SMS.CARD.CAMPAIGN_DETAILS.ON') }}
  </span>
  <span class="flex-1 text-sm font-medium truncate text-n-slate-12">
    {{ messageStamp(new Date(scheduledAt), 'LLL d, h:mm a') }}
  </span>

  <!-- NOTICE: KAPTION-INTEGRATION -->
  <!-- Campaign stats display -->
  <div class="flex items-center gap-2 ml-2 text-xs text-n-slate-11 flex-wrap">
    <span class="whitespace-nowrap">
      {{ stats?.sent ?? 0 }} {{ t('CAMPAIGN.WHATSAPP.CARD.STATS.SENT') }}
    </span>
    <span class="whitespace-nowrap">
      {{ stats?.delivered ?? 0 }}
      {{ t('CAMPAIGN.WHATSAPP.CARD.STATS.DELIVERED') }}
    </span>
    <span class="whitespace-nowrap">
      {{ stats?.read ?? 0 }} {{ t('CAMPAIGN.WHATSAPP.CARD.STATS.READ') }}
    </span>
    <span class="whitespace-nowrap">
      {{ stats?.replied ?? 0 }} {{ t('CAMPAIGN.WHATSAPP.CARD.STATS.REPLIED') }}
    </span>
    <span
      v-if="(stats?.failed ?? 0) > 0"
      class="whitespace-nowrap text-n-ruby-11"
    >
      {{ stats?.failed ?? 0 }} {{ t('CAMPAIGN.WHATSAPP.CARD.STATS.FAILED') }}
    </span>
  </div>
</template>
